// SPDX-FileCopyrightText: 2024 - 2025 Dusan Mijatovic (Netherlands eScience Center)
// SPDX-FileCopyrightText: 2024 - 2025 Netherlands eScience Center
// SPDX-FileCopyrightText: 2025 Christian Meeßen (GFZ) <christian.meessen@gfz-potsdam.de>
// SPDX-FileCopyrightText: 2025 Helmholtz Centre Potsdam - GFZ German Research Centre for Geosciences
//
// SPDX-License-Identifier: Apache-2.0
// SPDX-License-Identifier: EUPL-1.2

'use client'
import {menuItems, MenuItemType} from '~/config/menuItems'
import useRsdSettings from './useRsdSettings'

export default function useMenuItems(){
  // get host settings
  const {modules,activeModules} = useRsdSettings()
  const items:MenuItemType[] = []

  // loop active modules from settings to get menuItems order
  activeModules
    .forEach(name=>{
      // if there is menuItem for this module key=module
      if (menuItems.hasOwnProperty(name)){
        const item = menuItems[name]
        const rsdModule = modules[name]
        // we check if menu item should be shown based on settings.json
        if (rsdModule.hasOwnProperty('menuItem') && rsdModule.menuItem!==null){
          // we use custom label
          item.label = rsdModule.menuItem as string
          // we check if menu item should be shown based on menu active logic
          if (item.active && item?.active({modules:activeModules})){
            items.push(item)
          }
        }
      }
    })

  // console.group('useMenuItems')
  // console.log('items...', items)
  // console.groupEnd()

  return items

}
